var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "requisitions-applicant grid-x grid-padding-x grid-padding-y"
    },
    [
      _c(
        "div",
        { staticClass: "cell small-2" },
        [
          _c("applicants-sidebar", {
            attrs: {
              csrfToken: _vm.csrfToken,
              requisition: _vm.jobApplication.job.requisition,
              "default-applicant": _vm.jobApplication
            },
            on: {
              "applicant-loaded": _vm.applicantChanged,
              "phase-changed": _vm.phaseChanged
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cell small-10" },
        [
          _c("div", { staticClass: "flex" }, [
            _c("span", { staticClass: "p-2" }, [
              _c("strong", [_vm._v(_vm._s(_vm.jobApplication.user.full_name))]),
              _vm._v(" "),
              _vm.jobApplication.user
                ? _c("p", [
                    _vm.jobApplication.user.country_id === 246
                      ? _c("span", [
                          _vm._v(
                            "ID Number: " +
                              _vm._s(_vm.jobApplication.user.id_number)
                          )
                        ])
                      : _c("span", [
                          _vm._v(
                            "Passport Number: " +
                              _vm._s(_vm.jobApplication.user.passport_number)
                          )
                        ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.jobApplication.job.requisition.job_profile
                .external_requisition_number
                ? _c("p", [
                    _vm._v("External Req #: "),
                    _c("i", { staticStyle: { color: "red" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.jobApplication.job.requisition.job_profile
                            .external_requisition_number
                        )
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.jobApplication.job.requisition.job_profile
                .sage_job_requisition
                ? _c("p", [
                    _vm._v(
                      "\n                    Sage Job Req:\n                    "
                    ),
                    _c("i", { staticStyle: { color: "red" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.jobApplication.job.requisition.job_profile
                            .sage_job_requisition.job_title
                        )
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "p-2 documents icon black middle" }, [
              _c("i", {
                staticClass: "fa-solid fa-user-shield",
                attrs: {
                  title:
                    "Background Verification: " +
                    _vm.backgroundVerificationFailCount
                }
              }),
              _vm._v(" "),
              _vm.backgroundVerificationFailCount > 0
                ? _c("span", { staticClass: "notification-count" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.backgroundVerificationFailCount) +
                        "\n                "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "p-2 documents icon black" }, [
              _c("i", {
                staticClass: "fa-solid fa-phone-slash",
                attrs: { title: "Unavailable: " + _vm.unavailableCount }
              }),
              _vm._v(" "),
              _vm.unavailableCount > 0
                ? _c("span", { staticClass: "notification-count" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.unavailableCount) +
                        "\n                "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "p-2 documents icon black" }, [
              _c("i", {
                staticClass: "fa-solid fa-user-xmark",
                attrs: { title: "Not Showing Up: " + _vm.notShowingUpCount }
              }),
              _vm._v(" "),
              _vm.notShowingUpCount > 0
                ? _c("span", { staticClass: "notification-count" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.notShowingUpCount) +
                        "\n                "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "p-2 documents icon black" }, [
              _c("i", {
                staticClass: "fa-solid fa-circle-exclamation",
                attrs: {
                  title: "Previous Rejections: " + _vm.previousRejectionsCount
                }
              }),
              _vm._v(" "),
              _vm.previousRejectionsCount > 0
                ? _c("span", { staticClass: "notification-count" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.previousRejectionsCount) +
                        "\n                "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "p-2 documents icon black" }, [
              _c("i", {
                staticClass: "fa-solid fa-recycle",
                attrs: { title: "Recycles: " + _vm.recycleCount }
              }),
              _vm._v(" "),
              _vm.recycleCount > 0
                ? _c("span", { staticClass: "notification-count" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.recycleCount) +
                        "\n                "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.jobApplication.user.baseline_score
              ? _c("div", { staticClass: "p-2 documents icon black" }, [
                  _c("i", {
                    staticClass: "fa-solid fa-award",
                    attrs: {
                      title:
                        "Baseline Score: " +
                        _vm.jobApplication.user.baseline_score
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.jobApplication.user.id_path
              ? _c("div", { staticClass: "p-2 documents icon" }, [
                  _c("i", {
                    staticClass: "fa-regular fa-id-card",
                    attrs: { title: "ID Document" }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.hasMatric
              ? _c("div", { staticClass: "p-2 documents icon" }, [
                  _c("i", {
                    staticClass: "fa-solid fa-graduation-cap",
                    attrs: { title: "Matric Qualification" }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.jobApplication.user.user_detail !== null &&
            _vm.jobApplication.user.user_detail.user_detail_jobs
              ? _c("div", { staticClass: "p-2 documents icon" }, [
                  _c("i", {
                    staticClass: "fa-solid fa-briefcase",
                    attrs: { title: "Work Experience" }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.ifactFormEverConvicted &&
            _vm.ifactFormEverConvicted.is_ever_convicted
              ? _c("div", { staticClass: "p-2 documents icon text-danger" }, [
                  _c("i", {
                    staticClass: "fa-solid fa-flag",
                    attrs: {
                      title: _vm.ifactFormEverConvicted.document_url
                        ? "Candidate information could not be retrieved, please view iFacts form for more conviction info"
                        : _vm.ifactFormEverConvicted.conviction_details
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "padding-left" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-success mycalling-green documents",
                  attrs: {
                    href:
                      "/recruiter/ifacts/index?application_id=" +
                      _vm.jobApplication.id
                  }
                },
                [_vm._v("Ifacts")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-success mycalling-green documents",
                  attrs: {
                    href: "" + _vm.jobApplication.user.cv_url,
                    download: ""
                  }
                },
                [_vm._v("Download CV")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-success mycalling-green documents",
                  on: {
                    click: function($event) {
                      return _vm.toggleModal("candidateOverviewModal")
                    }
                  }
                },
                [_vm._v("Candidate Overview")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-success mycalling-green documents",
                  on: {
                    click: function($event) {
                      return _vm.toggleModal("quickMessageModal")
                    }
                  }
                },
                [_vm._v("Quick Message")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-success mycalling-green documents",
                  on: {
                    click: function($event) {
                      return _vm.toggleModal("exportStageModal")
                    }
                  }
                },
                [_vm._v("Export Stages")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-success mycalling-green documents",
                  attrs: {
                    href:
                      "/recruiter/user-documents/index/" +
                      _vm.jobApplication.user_id +
                      "?aplication_id=" +
                      _vm.jobApplication.id
                  }
                },
                [_vm._v("Additional documents")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-success mycalling-green documents",
                  on: {
                    click: function($event) {
                      return _vm.toggleModal("recruiterNotesModal")
                    }
                  }
                },
                [_vm._v("Recruiter Notes")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-success mycalling-green documents",
                  attrs: {
                    href:
                      "/recruiter/active-requisitions/impersonate/" +
                      _vm.jobApplication.id
                  }
                },
                [_vm._v("Impersonate/Edit")]
              ),
              _vm._v(" "),
              (_vm.jobApplication.application_phase == "start" ||
                _vm.jobApplication.application_phase == "loading_offer") &&
              _vm.jobApplication.job.requisition.job_profile
                .external_requisition_number &&
              _vm.jobApplication.job.requisition.job_profile
                .sage_job_requisition_id
                ? _c(
                    "a",
                    {
                      staticClass: "btn btn-success mycalling-green documents",
                      on: { click: _vm.sendToSage }
                    },
                    [_vm._v("Send to Sage")]
                  )
                : _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-primary mycalling-green documents disabled",
                      staticStyle: {
                        "pointer-events": "all",
                        "background-color": "#CCCCCC",
                        "border-color": "#CCCCCC"
                      },
                      attrs: {
                        disabled: "",
                        title:
                          "You can not Send to Sage, please check that there is the correct External Req # and Sage Req ID linked to this candidate application, and that they are in Start or Loading Offer before trying again."
                      }
                    },
                    [_vm._v("Send to Sage")]
                  )
            ])
          ]),
          _vm._v(" "),
          _c(
            "tabs",
            { attrs: { selected: "#" + _vm.currentTab } },
            [
              _c(
                "tab",
                {
                  staticClass: "p-4",
                  attrs: { name: "Loading CV", "override-href": "loading_cv" }
                },
                [
                  _c("Cv", {
                    attrs: {
                      csrfToken: _vm.csrfToken,
                      jobApplication: _vm.jobApplication,
                      module: _vm.module,
                      "trait-statements-by-cluster":
                        _vm.traitStatementsByCluster,
                      failedJobApplications: _vm.failedJobApplications
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "tab",
                {
                  staticClass: "p-2",
                  attrs: {
                    name: "Killer Questions",
                    "override-href": "killer_questions"
                  }
                },
                [
                  _c("KillerQuestions", {
                    attrs: {
                      "job-application": _vm.jobApplication,
                      "csrf-token": _vm.csrfToken,
                      logs: _vm.applicationPhaseLogs.killer_questions
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.atsType != "leadership_and_support"
                ? _c(
                    "tab",
                    {
                      staticClass: "p-2",
                      attrs: {
                        name: "Voice Assessment",
                        "override-href": "language_proficiency"
                      }
                    },
                    [
                      _c("LanguageProficiency", {
                        attrs: {
                          "job-application": _vm.jobApplication,
                          "csrf-token": _vm.csrfToken,
                          logs: _vm.applicationPhaseLogs.language_proficiency
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "tab",
                {
                  attrs: {
                    name:
                      _vm.atsType == "leadership_and_support"
                        ? "Telephonic CV screening"
                        : "Telephonic screening",
                    "override-href": "telephonic_screening"
                  }
                },
                [
                  _c("TelephonicScreening", {
                    attrs: {
                      "job-application": _vm.jobApplication,
                      "csrf-token": _vm.csrfToken,
                      module: _vm.module,
                      "trait-statements-by-cluster":
                        _vm.traitStatementsByCluster,
                      "interview-answers": _vm.interviewAnswers,
                      "interview-scores": _vm.interviewScores,
                      logs: _vm.applicationPhaseLogs.telephonic_screening,
                      "id-verification-check": _vm.idVerificationCheck
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "tab",
                {
                  attrs: {
                    name: "1st Interview",
                    "override-href": "first_interview"
                  }
                },
                [
                  _c("FirstInterview", {
                    attrs: {
                      "job-application": _vm.jobApplication,
                      "csrf-token": _vm.csrfToken,
                      module: _vm.module,
                      "trait-statements-by-cluster":
                        _vm.traitStatementsByCluster,
                      "interview-answers": _vm.interviewAnswers,
                      "interview-scores": _vm.interviewScores,
                      logs: _vm.applicationPhaseLogs.first_interview
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.atsType == "leadership_and_support"
                ? _c(
                    "tab",
                    {
                      staticClass: "p-2",
                      attrs: {
                        name: "Background Verification",
                        "override-href": "background_verification"
                      }
                    },
                    [
                      _c("BackgroundVerification", {
                        attrs: {
                          "job-application": _vm.jobApplication,
                          "csrf-token": _vm.csrfToken,
                          logs:
                            _vm.applicationPhaseLogs.background_verification,
                          "ats-type": _vm.atsType,
                          "panel-interview-logs":
                            _vm.applicationPhaseLogs.panel_interview
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "tab",
                {
                  staticClass: "p-2",
                  attrs: {
                    name:
                      _vm.atsType == "leadership_and_support"
                        ? "Psychometric Assessment"
                        : "Skill Assessment",
                    "override-href": "skills_assessment"
                  }
                },
                [
                  _c("SkillAssessment", {
                    attrs: {
                      "job-application": _vm.jobApplication,
                      "csrf-token": _vm.csrfToken,
                      logs: _vm.applicationPhaseLogs.skills_assessment
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "tab",
                {
                  attrs: {
                    name: "Panel Interview",
                    "override-href": "panel_interview"
                  }
                },
                [
                  _c("PanelInterview", {
                    attrs: {
                      "job-application": _vm.jobApplication,
                      "csrf-token": _vm.csrfToken,
                      module: _vm.module,
                      "trait-statements-by-cluster":
                        _vm.traitStatementsByCluster,
                      "interview-answers": _vm.interviewAnswers,
                      "interview-scores": _vm.interviewScores,
                      logs: _vm.applicationPhaseLogs.panel_interview
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.atsType != "leadership_and_support"
                ? _c(
                    "tab",
                    {
                      staticClass: "p-2",
                      attrs: {
                        name: "Background Verification",
                        "override-href": "background_verification"
                      }
                    },
                    [
                      _c("BackgroundVerification", {
                        attrs: {
                          "job-application": _vm.jobApplication,
                          "csrf-token": _vm.csrfToken,
                          logs:
                            _vm.applicationPhaseLogs.background_verification,
                          "ats-type": _vm.atsType,
                          "panel-interview-logs":
                            _vm.applicationPhaseLogs.panel_interview
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.jobApplication.job.requisition.is_pipeline
                ? _c(
                    "tab",
                    {
                      attrs: {
                        name: "Loading Offer",
                        "override-href": "loading_offer"
                      }
                    },
                    [
                      _c("LoadingOffer", {
                        attrs: {
                          "job-application": _vm.jobApplication,
                          "csrf-token": _vm.csrfToken,
                          logs: _vm.applicationPhaseLogs.loading_offer,
                          "sage-log": _vm.sageLog
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.jobApplication.job.requisition.is_pipeline
                ? _c(
                    "tab",
                    {
                      attrs: {
                        name: "Onboarding",
                        "override-href": "onboarding"
                      }
                    },
                    [
                      _c("Onboarding", {
                        attrs: {
                          "job-application": _vm.jobApplication,
                          "csrf-token": _vm.csrfToken,
                          logs: _vm.applicationPhaseLogs.onboarding,
                          "sage-log": _vm.sageLog,
                          "enable-send-to-sage":
                            _vm.jobApplication.job.requisition.job_profile
                              .external_requisition_number &&
                            _vm.jobApplication.job.requisition.job_profile
                              .sage_job_requisition_id &&
                            _vm.jobApplication.job.requisition.job_profile
                              .external_requisition_number !== "" &&
                            _vm.jobApplication.job.requisition.job_profile
                              .sage_job_requisition_id !== ""
                              ? true
                              : false
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.jobApplication.job.requisition.is_pipeline
                ? _c(
                    "tab",
                    { attrs: { name: "Start", "override-href": "start" } },
                    [
                      _c("Start", {
                        attrs: {
                          "job-application": _vm.jobApplication,
                          "csrf-token": _vm.csrfToken,
                          logs: _vm.applicationPhaseLogs.start,
                          "sage-log": _vm.sageLog
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("quick-message-modal", {
            ref: "quickMessageModal",
            attrs: {
              "job-application": _vm.jobApplication,
              "csrf-token": _vm.csrfToken
            }
          }),
          _vm._v(" "),
          _c("recruiter-notes-modal", {
            ref: "recruiterNotesModal",
            attrs: {
              "job-application": _vm.jobApplication,
              "csrf-token": _vm.csrfToken
            }
          }),
          _vm._v(" "),
          _c("export-stage-modal", {
            ref: "exportStageModal",
            attrs: {
              "job-application": _vm.jobApplication,
              "csrf-token": _vm.csrfToken
            }
          }),
          _vm._v(" "),
          _c("candidate-overview-modal", {
            ref: "candidateOverviewModal",
            attrs: {
              "job-application": _vm.jobApplication,
              "csrf-token": _vm.csrfToken
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78bc22c2", { render: render, staticRenderFns: staticRenderFns })
  }
}